export default {
  getIngredients: state => state.ingredients
}